module.exports = __webpack_public_path__ + "img/marketing.d6917bb9.svg";